module.exports = __webpack_public_path__ + "img/trade-bg-keys-and-car.6fe32a73.jpeg";